import { render, staticRenderFns } from "./MenuArea.vue?vue&type=template&id=e0f0d40e&"
import script from "./MenuArea.vue?vue&type=script&lang=js&"
export * from "./MenuArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports